
import React from 'react';
import Layout from '@/components/Layout/Layout';
import TipCalculator from '@/components/SpecialCalculators/TipCalculator';
import { Link } from 'react-router-dom';

const TipCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="text-sm text-gray-500 mb-2">
            <Link to="/" className="hover:underline">Home</Link> {' > '} 
            <Link to="/special" className="hover:underline">Special Tools</Link> {' > '} 
            <span>Tip Calculator</span>
          </div>
          <h1 className="text-3xl font-bold mb-3">Tip Calculator</h1>
          <p className="text-gray-700">
            Calculate tips for restaurants and services quickly and easily. Determine how much to tip and split bills among multiple people.
          </p>
        </div>

        {/* Calculator Section */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8">
          <TipCalculator />
        </div>

        {/* Information Section */}
        <div className="bg-[#E6F3FF] p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-3">How to use the Tip Calculator</h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-2">
            <li>Enter the total bill amount before tip</li>
            <li>Adjust the tip percentage using the slider (default is 15%)</li>
            <li>Enter the number of people to split the bill with (default is 1)</li>
            <li>The calculator will automatically show the tip amount, total bill, and amount per person</li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">About Tipping</h2>
          <p className="text-gray-700 mb-3">
            Tipping is customary in many countries to show appreciation for services. In the United States, a standard tip 
            for restaurant service typically ranges between 15-20% of the pre-tax bill amount. For exceptional service, 
            some may tip more than 20%.
          </p>
          <p className="text-gray-700 mb-3">
            When dining with a group, splitting the bill and calculating the appropriate tip can be challenging. This 
            calculator streamlines the process by calculating both the total amount (with tip) and how much each person should pay.
          </p>
        </div>

        {/* Related Calculators */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">Related Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/special" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">🍽️</span> Percentage Calculator
            </Link>
            <Link to="/special" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💰</span> Currency Calculator
            </Link>
            <Link to="/special" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">➗</span> Split Bill Calculator
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TipCalculatorPage;
